/* Scroll parallax for split-feature media ([data-ofwm-parallax]).
   Translates the oversized image (130% height) against scroll direction,
   gated by IntersectionObserver and prefers-reduced-motion. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let items = [];
  let ticking = false;

  const update = () => {
    ticking = false;
    if (reducedMotion.matches) return;
    const viewportHeight = window.innerHeight;
    for (const item of items) {
      if (!item.visible) continue;
      const rect = item.media.getBoundingClientRect();
      const rawProgress =
        (rect.top + rect.height / 2 - viewportHeight / 2) / ((viewportHeight + rect.height) / 2);
      const progress = Math.max(-1, Math.min(1, rawProgress));
      const travel = (item.image.offsetHeight - rect.height) / 2;
      item.image.style.transform = `translate3d(0, ${(-progress * travel).toFixed(1)}px, 0)`;
    }
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const item = items.find((candidate) => candidate.media === entry.target);
      if (item) item.visible = entry.isIntersecting;
    }
    requestUpdate();
  });

  const init = () => {
    observer.disconnect();
    items = [];
    document.querySelectorAll('[data-ofwm-parallax]').forEach((media) => {
      const image = media.querySelector('img, svg');
      if (!image) return;
      items.push({ media, image, visible: false });
      observer.observe(media);
    });
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', init);
  reducedMotion.addEventListener('change', () => {
    items.forEach((item) => (item.image.style.transform = ''));
    requestUpdate();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
